import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  withStyles,
} from 'material-ui';
import MealSwitchStyles from './MealSwitchStyles';
import MealSubselectionSwitch from './MealSubselectionSwitch';

let subselectionButtons;

const MealSwitch = ({
  meals,
  label,
  name,
  value,
  subselection,
  onSelection,
  onSubselection,
  classes,
}) => (
  <div className={classes.root}>
    <FormControl component='fieldset' className={classes.formControl}>
      <FormLabel classes={{ root: classes.label, focused: classes.checked }}>{label}</FormLabel>
      <Paper>
        <RadioGroup
          aria-label='meal'
          name={name}
          className={classes.group}
          value={value}
          onChange={onSelection}
        >
          {meals.map(
            (meal, index) =>
              meal.subselection ? (
                [
                  <FormControlLabel
                    key={`meal-item-${meal.id}-${index}`}
                    value={meal.id}
                    control={<Radio classes={{ checked: classes.checked }} />}
                    label={meal.description}
                  />,
                  <MealSubselectionSwitch
                    key={`meal-item-subselection-${meal.subselection.label}`}
                    parentValue={meal.id}
                    value={subselection}
                    name={name}
                    onSubselection={onSubselection}
                    meals={meal.subselection.options}
                    label={meal.subselection.label}
                  />,
                ].map(item => item)
              ) : (
                <FormControlLabel
                  key={`meal-item-${meal.id}-${index}`}
                  value={meal.id}
                  control={<Radio classes={{ checked: classes.checked }} />}
                  label={meal.description}
                />
              )
          )}
          {subselectionButtons}
        </RadioGroup>
      </Paper>
    </FormControl>
  </div>
);

MealSwitch.propTypes = {
  classes: PropTypes.object,
  meals: PropTypes.arrayOf(PropTypes.object),
  name: PropTypes.string,
  value: PropTypes.string,
  subselection: PropTypes.string,
  label: PropTypes.string,
  onSelection: PropTypes.func,
  onSubselection: PropTypes.func,
};

export default withStyles(MealSwitchStyles)(MealSwitch);



// WEBPACK FOOTER //
// ./src/components/meals/mealSwitch/MealSwitch.js